export const showHelp = (state) => state.help

export const files = (state) => {
	return state.caseFile.find(item => item.client_id == state.currentClient)
}